import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BUSINESS } from "@/data/site";
import { Logo } from "@/components/Logo";

const LINKS = [
  { to: "/#servizi", label: "Servizi", testid: "nav-link-servizi" },
  { to: "/#normativa", label: "Normativa", testid: "nav-link-normativa" },
  { to: "/#chi-siamo", label: "Chi Siamo", testid: "nav-link-chi-siamo" },
  { to: "/#faq", label: "FAQ", testid: "nav-link-faq" },
  { to: "/blog", label: "Blog", testid: "nav-link-blog" },
  { to: "/#contatti", label: "Contatti", testid: "nav-link-contatti" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onBlog = location.pathname.startsWith("/blog");

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-ink/10 bg-paper/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center"
          onClick={() => setOpen(false)}
        >
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Navigazione principale">
          {LINKS.map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              data-testid={l.testid}
              className={`font-mono text-[11px] tracking-[0.18em] uppercase transition-colors hover:text-clinic ${
                onBlog && l.label === "Blog" ? "text-clinic" : "text-ink/70"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <a
            href={`mailto:${BUSINESS.email}?subject=Richiesta%20preventivo%20sorveglianza%20sanitaria`}
            data-testid="nav-cta-preventivo"
            className="rounded-full bg-clinic px-5 py-2.5 font-mono text-[11px] tracking-[0.15em] uppercase text-white transition-transform hover:-translate-y-0.5"
          >
            Preventivo via Email
          </a>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          className="lg:hidden text-ink"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Chiudi menu" : "Apri menu"}
        >
          {open ? <MenuCloseIcon /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-ink/10 bg-paper px-5 py-4 flex flex-col gap-4"
          aria-label="Menu mobile"
        >
          {LINKS.map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="font-mono text-xs tracking-[0.18em] uppercase text-ink/80"
            >
              {l.label}
            </Link>
          ))}
          <a
            href={`mailto:${BUSINESS.email}?subject=Richiesta%20preventivo%20sorveglianza%20sanitaria`}
            data-testid="nav-cta-preventivo-mobile"
            className="rounded-full bg-clinic px-5 py-3 text-center font-mono text-[11px] tracking-[0.15em] uppercase text-white"
          >
            Preventivo via Email
          </a>
        </nav>
      )}
    </header>
  );
};

const MenuCloseIcon = () => <X size={24} />;
